import './App.css';
import './TopNavigation/TopBar'
import LeftSide from './LeftSide/LeftSide';
import MainContent from './MainContent/MainContent';
import FrontPage from './FrontPage/FrontPage';
import { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import background from './Resources/Backgrounds/background1.jpg';
import mobileBackground from './Resources/Backgrounds/background2.jpg'
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Slide } from '@mui/material';

const darkBlue = "#0f1922";
const tomatoRed = "#ff4654";
function App() {
  const [open, setOpen] = useState(true);

  /* Firebase stuff */
  // Import the functions you need from the SDKs you need

  // TODO: Add SDKs for Firebase products that you want to use
  // https://firebase.google.com/docs/web/setup#available-libraries

  // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  const firebaseConfig = {
    apiKey: "AIzaSyAoqzjsap-8FzMFrCAulBRkRZ6-gtyWJiU",
    authDomain: "strat-roulette-prod.firebaseapp.com",
    projectId: "strat-roulette-prod",
    storageBucket: "strat-roulette-prod.appspot.com",
    messagingSenderId: "679542994675",
    appId: "1:679542994675:web:cece81ed56c600fe1ea986",
    measurementId: "G-GMB42YTD82"
  };

  // Initialize Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  /* End of  Firebase stuff */

  return (
    <>
      <div className='flex height-100'>
        <LeftSide />
        <MainContent />
        <Dialog
          open={open}
          onClose={() => setOpen(false)}
          aria-describedby="alert-dialog-slide-description"
          style={{ background: "transparent" }}
        >
          <DialogTitle style={{ background: darkBlue, color: "white" }}>{"New Cypher Misison Available"}</DialogTitle>
          <DialogContent style={{ background: darkBlue }}>
            <DialogContentText id="alert-dialog-slide-description" style={{ color: tomatoRed }}>

              <a href="https://playtivity.web.app/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: 'none' }}> Cypher needs your help! Play Now: </a>
              <a href="https://playtivity.web.app/" target="_blank" rel="noreferrer" style={{ color: "white", textDecoration: 'underline' }}>Cypher's Quest!</a>

            </DialogContentText>
          </DialogContent>
          <DialogActions style={{ background: darkBlue, color: tomatoRed }}>
            <Button onClick={() => setOpen(false)} style={{ color: tomatoRed, fontWeight: 'bold' }}>Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default App;
